import { Checkbox } from "@mui/material";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import { CatalogBin } from "../../../models/CatalogBin";
import { useCatalogBinContext } from "../context/CatalogBinContext";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  setBin: (bin: CatalogBin) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};
export const useTableData = ({
  setBin,
  setShowModal,
  showContextMenu,
}: Props) => {
  const { state } = useCatalogBinContext();
  const rows: CatalogBin[] =
    state.bins?.map((bin) => ({
      ...bin,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      field: "BinName",
      headerName: "Name",
      flex: 2,
      cellStyle: cellStyle,
    },
    {
      field: "MaterialName",
      headerName: "Material",
      type: ["nonSorteable", "nonFilterable", "centerAligned"],
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "L1MaterialId",
      headerName: "L1 Material Id",
      type: ["nonSorteable", "nonFilterable", "centerAligned"],
      flex: 1,
    },
    {
      field: "Enabled",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setBin,
        data: params.data as CatalogBin,
        setShowModal: setShowModal,
        del: false,
        showContextMenu: () =>
          showContextMenu(event, params.data, "binContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 330,
      filter: false,
      autoHeaderHeight: true,
    },
  ];
  return { rows, columnDefs };
};
